// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"86507a99","422":"209061a6","714":"850f02ae"}[chunkId] + ".chunk.js";
};